import { lens } from '@dhmk/zustand-lens'

import type { DeviceSettingsAction } from './actions'
import { createDeviceSettingsActions } from './actions'
import type { IDeviceSettingsState } from './state'
import { createDeviceSettingsState } from './state'

export const DEVICE_SETTINGS_SLICE_KEY = 'deviceSettings'

export interface IDeviceSettingsSlice {
  [DEVICE_SETTINGS_SLICE_KEY]: IDeviceSettingsState & {
    actions: DeviceSettingsAction
  }
}

/**
 *
 */
export function createDeviceSettingsSlice(): IDeviceSettingsSlice {
  return {
    [DEVICE_SETTINGS_SLICE_KEY]: lens((set) => ({
      ...createDeviceSettingsState(),
      actions: createDeviceSettingsActions(set),
    })),
  }
}
